/* ============================================================
 * personalizer.js
 * Personalizador de tazas adaptado a Shopify Liquid.
 * Lee la config de la plantilla desde un <script type="application/json">
 * que la sección Liquid renderiza con el metafield del producto.
 *
 * Combina las funciones de los módulos originales:
 *   state, canvas-utils, render, curved-text, upload, drag-handlers,
 *   composite, custom-text  +  lógica nueva de submit-to-cart.
 * ============================================================ */
(function () {
  'use strict';

  // ============================================================
  //  CONFIG GLOBAL
  // ============================================================
  const CLOUDINARY_CLOUD_NAME = window.PERSONALIZER_CLOUD_NAME || 'TU_CLOUD_NAME';
  const CLOUDINARY_UPLOAD_PRESET = window.PERSONALIZER_UPLOAD_PRESET || 'TU_PRESET';

  // ============================================================
  //  i18n — mensajes bilingües
  // ============================================================
  const MSG = {
    es: {
      photoUploaded: 'Foto subida. Arrastra para ajustar encuadre.',
      photoSavedCloud: 'Foto guardada en la nube ✓',
      cloudError: '⚠ Error al subir foto a la nube. Inténtalo de nuevo.',
      textAdded: 'Texto añadido. Arrastra para mover, doble click para editar.',
      textDeleted: 'Texto eliminado.',
      uploadingWait: 'Esperando que terminen las subidas…',
      missingPhotos: function(n){ return 'Faltan ' + n + ' fotos por subir.'; },
      generatingPreview: 'Generando preview…',
      addToCart: 'Añadir al carrito',
      popupBlocked: 'Permite ventanas emergentes para ver el preview',
      photosReset: 'Fotos y textos reseteados.',
      confirmReset: '¿Borrar todas las fotos y textos personalizados?',
      clickToUpload: 'Haz click en cualquier zona para subir fotos.',
      previewGenError: 'Error generando el preview: ',
      noFormFound: 'Falta el form de carrito',
      threeNotLoaded: 'Cargando vista 3D…',
      defaultText: 'Tu texto aquí'
    },
    en: {
      photoUploaded: 'Photo uploaded. Drag to adjust framing.',
      photoSavedCloud: 'Photo saved to cloud ✓',
      cloudError: '⚠ Error uploading photo. Try again.',
      textAdded: 'Text added. Drag to move, double-click to edit.',
      textDeleted: 'Text deleted.',
      uploadingWait: 'Waiting for uploads to finish…',
      missingPhotos: function(n){ return n + ' photos missing.'; },
      generatingPreview: 'Generating preview…',
      addToCart: 'Add to cart',
      popupBlocked: 'Allow popups to see the preview',
      photosReset: 'Photos and texts reset.',
      confirmReset: 'Delete all photos and custom texts?',
      clickToUpload: 'Click on any zone to upload photos.',
      previewGenError: 'Error generating preview: ',
      noFormFound: 'Cart form not found',
      threeNotLoaded: 'Loading 3D view…',
      defaultText: 'Your text here'
    }
  };
  function t(key) {
    var lang = (document.body && document.body.classList.contains('lang-es')) ? 'es' : 'en';
    var val = MSG[lang][key];
    if (typeof val === 'function') return val.apply(null, Array.prototype.slice.call(arguments, 1));
    return val || MSG.es[key] || key;
  }

  // ============================================================
  //  ARRANQUE
  // ============================================================
  var _booted = false;

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();

  function initAll() {
    if (_booted) return;
    _booted = true;

    document.querySelectorAll('.personalizer-wrap[data-template]').forEach(wrap => {
      try {
        bootInstance(wrap);
      } catch (err) {
        console.error('[personalizer] error inicializando:', err);
      }
    });
  }

  // ============================================================
  //  UNA INSTANCIA POR PRODUCTO (por si hay varios en la misma página)
  // ============================================================
  function bootInstance(wrap) {
    const productId = wrap.dataset.productId;
    const configEl = wrap.querySelector('script[type="application/json"].tpl-config');
    if (!configEl) {
      console.warn('[personalizer] no se encontró el JSON de config');
      return;
    }
    const tpl = JSON.parse(configEl.textContent);

    // Resolver URL del fondo: si no es URL completa, asume archivo en /assets/
    // Importante: assetBase de Shopify suele venir con query string (?v=123)
    // Hay que limpiarlo antes de concatenar el filename.
    function buildAssetUrl(filename) {
      const rawBase = wrap.dataset.assetBase || '';
      const base = rawBase.split('?')[0];   // strip ?v=xxx cache-busting
      return base + filename;
    }
    if (tpl.backgroundImage && !/^https?:\/\//.test(tpl.backgroundImage) && !tpl.backgroundImage.startsWith('//')) {
      tpl.backgroundImage = buildAssetUrl(tpl.backgroundImage);
    }
    if (tpl.overlayImage && !/^https?:\/\//.test(tpl.overlayImage) && !tpl.overlayImage.startsWith('//')) {
      tpl.overlayImage = buildAssetUrl(tpl.overlayImage);
    }

    // ============================================================
    //  STATE
    // ============================================================
    const state = {
      tpl,                       // ← config completa de la plantilla
      photos: {},                // { zoneId: dataURL local (preview) }
      photoUrls: {},             // { zoneId: URL pública (Cloudinary) tras subir }
      offsets: {},               // { zoneId: {x,y} % de pan dentro de la zona }
      texts: {},                 // textos predefinidos editables
      customTexts: [],           // textos añadidos por el cliente
      selectedZone: null,
      selectedCustomTextId: null,
      pendingZoneId: null,
      customTextIdCounter: 0,
      uploading: 0,              // contador de subidas a Cloudinary en curso
    };

    // ============================================================
    //  HELPERS DE BÚSQUEDA EN EL DOM (scoped al wrap)
    // ============================================================
    const $ = sel => wrap.querySelector(sel);

    const canvasBg        = $('.canvas-bg');
    const zonesContainer  = $('.zones-container');
    const textsContainer  = $('.texts-container');
    const canvasOverlay   = $('.canvas-overlay');
    const statusEl        = $('.personalizer-status');
    // El file input está FUERA del form de Shopify (siblings del wrap), buscar a nivel documento
    const fileInput       = document.querySelector('.personalizer-file-input');
    const addTextBtn      = $('.add-text-btn');
    const previewBtn      = $('.preview-btn');
    // submit-btn está en la purchase bar, FUERA del wrap → buscar en la sección o documento
    const submitBtn       = wrap.closest('.pph-page, section')?.querySelector('.submit-btn')
                            || document.querySelector('.submit-btn');
    const resetBtn        = $('.reset-btn');
    const stepIndicator   = $('.step-indicator');
    const formEl          = wrap.closest('form') || wrap.querySelector('form');
    const propsDataEl     = wrap.querySelector('.personalization-data');
    const propsPhotosEl   = wrap.querySelector('.personalization-photos');
    const propsPreviewEl  = wrap.querySelector('.personalization-preview');
    const textToolbar     = $('.text-toolbar');
    const tbFont          = $('.tb-font');
    const tbSize          = $('.tb-size');
    const tbBold          = $('.tb-bold');
    const tbItalic        = $('.tb-italic');
    const tbColor         = $('.tb-color');
    const tbDelete        = $('.tb-delete');
    const customClipsDefs = $('.custom-clips-defs');
    const curvedSvg       = $('.curved-text-svg');
    const curvedPaths     = $('.curved-text-paths');
    const curvedGroup     = $('.curved-text-group');
    const curvedEditor    = $('.curved-text-editor');
    const curvedInput     = $('.curved-text-input');

    function setStatus(msg) {
      if (statusEl) statusEl.textContent = msg;
    }

    // ============================================================
    //  CANVAS-UTILS — sample puntos de un path SVG (para texto curvo)
    // ============================================================
    function samplePathPoints(pathD, numPoints, vb, designX, designY, designW, designH) {
      const svgNS = 'http://www.w3.org/2000/svg';
      const tempSvg = document.createElementNS(svgNS, 'svg');
      const tempPath = document.createElementNS(svgNS, 'path');
      tempPath.setAttribute('d', pathD);
      tempSvg.appendChild(tempPath);
      document.body.appendChild(tempSvg);
      const totalLength = tempPath.getTotalLength();
      const points = [];
      for (let i = 0; i < numPoints; i++) {
        const t = i / Math.max(1, numPoints - 1);
        const pt = tempPath.getPointAtLength(t * totalLength);
        const cx = designX + (pt.x / vb.w) * designW;
        const cy = designY + (pt.y / vb.h) * designH;
        points.push({ x: cx, y: cy });
      }
      document.body.removeChild(tempSvg);
      return points;
    }

    // ============================================================
    //  RENDER
    // ============================================================
    function renderCanvas() {
      const tpl = state.tpl;
      const vb = tpl.viewBox;

      canvasBg.style.paddingBottom = (vb.h / vb.w * 100) + '%';
      canvasBg.style.backgroundColor = tpl.canvasBgColor || '#fff';
      canvasBg.style.backgroundImage = tpl.backgroundImage ? `url(${tpl.backgroundImage})` : 'none';

      if (tpl.overlayImage && canvasOverlay) {
        canvasOverlay.src = tpl.overlayImage;
        canvasOverlay.style.display = 'block';
      } else if (canvasOverlay) {
        canvasOverlay.style.display = 'none';
      }

      // clipPaths personalizados
      if (customClipsDefs) {
        customClipsDefs.innerHTML = '';
        (tpl.photoZones || []).forEach(zone => {
          if (zone.customPath) {
            const scaledPath = zone.customPath.replace(/([0-9.]+),([0-9.]+)/g, (m, x, y) => {
              return (parseFloat(x)/100).toFixed(4) + ',' + (parseFloat(y)/100).toFixed(4);
            });
            const svgNS = 'http://www.w3.org/2000/svg';
            const cp = document.createElementNS(svgNS, 'clipPath');
            cp.setAttribute('id', `clip_${productId}_${zone.id}`);
            cp.setAttribute('clipPathUnits', 'objectBoundingBox');
            const p = document.createElementNS(svgNS, 'path');
            p.setAttribute('d', scaledPath);
            cp.appendChild(p);
            customClipsDefs.appendChild(cp);
          }
        });
      }

      if (curvedSvg) curvedSvg.setAttribute('viewBox', `0 0 ${vb.w} ${vb.h}`);

      // Photo zones
      zonesContainer.innerHTML = '';
      (tpl.photoZones || []).forEach(zone => {
        const el = document.createElement('div');
        el.className = 'photo-zone';
        el.dataset.zoneId = zone.id;
        el.style.left   = (zone.x / vb.w * 100) + '%';
        el.style.top    = (zone.y / vb.h * 100) + '%';
        el.style.width  = (zone.w / vb.w * 100) + '%';
        el.style.height = (zone.h / vb.h * 100) + '%';
        el.style.transform = `rotate(${zone.rotation || 0}deg)`;
        el.style.transformOrigin = 'center center';
        el.style.zIndex = String(zone.z || 1);
        el.style.setProperty('--unrotate', `${-(zone.rotation || 0)}deg`);

        if (zone.customPath) {
          el.classList.add('custom-shape');
          el.style.setProperty('--clip-url', `url(#clip_${productId}_${zone.id})`);
        }
        if (zone.shape === 'circle') el.classList.add('circle-shape');

        if (state.photos[zone.id]) {
          const img = document.createElement('img');
          img.src = state.photos[zone.id];
          const off = state.offsets[zone.id] || {x:50,y:50};
          img.style.objectPosition = `${off.x}% ${off.y}%`;
          el.appendChild(img);
        } else {
          el.classList.add('empty');
        }

        el.addEventListener('click', e => handleZoneClick(zone.id, e));
        zonesContainer.appendChild(el);
      });

      // Text overlays editables
      textsContainer.innerHTML = '';
      (tpl.textFields || []).forEach(field => {
        const value = state.texts[field.id] !== undefined ? state.texts[field.id] : field.defaultValue;
        const el = document.createElement('div');
        el.className = 'text-overlay';
        el.dataset.fieldId = field.id;
        el.setAttribute('contenteditable', 'false');
        el.setAttribute('spellcheck', 'false');
        el.style.left = (field.x / vb.w * 100) + '%';
        el.style.top  = (field.y / vb.h * 100) + '%';
        const fsPercent = (field.fontSize / vb.w) * 100;
        el.style.fontSize = `${fsPercent}cqw`;
        el.style.fontFamily = field.fontFamily;
        el.style.fontStyle  = field.fontStyle;
        el.style.fontWeight = field.fontWeight;
        el.style.color = field.color;
        if (field.letterSpacing) el.style.letterSpacing = (field.letterSpacing / vb.w * 100) + 'cqw';
        el.style.transform = field.rotation
          ? `translate(-50%, -50%) rotate(${field.rotation}deg)`
          : `translate(-50%, -50%)`;
        el.textContent = value;

        el.addEventListener('click', (ev) => {
          ev.stopPropagation();
          if (el.classList.contains('editing')) return;
          el.classList.add('editing');
          el.setAttribute('contenteditable', 'true');
          el.focus();
          const range = document.createRange();
          range.selectNodeContents(el);
          const sel = window.getSelection();
          sel.removeAllRanges(); sel.addRange(range);
        });
        el.addEventListener('keydown', (ev) => {
          if (ev.key === 'Enter')  { ev.preventDefault(); el.blur(); }
          if (ev.key === 'Escape') { el.textContent = value; el.blur(); }
        });
        el.addEventListener('input', () => {
          const maxLen = field.maxLength || 100;
          if (el.textContent.length > maxLen) {
            el.textContent = el.textContent.slice(0, maxLen);
            const range = document.createRange();
            const sel = window.getSelection();
            range.selectNodeContents(el); range.collapse(false);
            sel.removeAllRanges(); sel.addRange(range);
          }
        });
        el.addEventListener('blur', () => {
          const newText = el.textContent.trim() || field.defaultValue;
          state.texts[field.id] = newText;
          el.textContent = newText;
          el.classList.remove('editing');
          el.setAttribute('contenteditable', 'false');
          window.getSelection().removeAllRanges();
        });
        textsContainer.appendChild(el);
      });

      renderCustomTexts(tpl, vb);
      renderCurvedTexts(tpl, vb);
      attachDragHandlers();
    }

    // ============================================================
    //  TEXTOS CURVOS
    // ============================================================
    function renderCurvedTexts(tpl, vb) {
      if (!curvedPaths || !curvedGroup) return;
      curvedPaths.innerHTML = '';
      curvedGroup.innerHTML = '';
      const fields = tpl.curvedTextFields || [];
      fields.forEach(field => {
        const value = state.texts[field.id] !== undefined ? state.texts[field.id] : field.defaultValue;
        if (!value) return;
        const pathId = `curvedpath_${productId}_${field.id}`;
        const pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathEl.setAttribute('id', pathId);
        pathEl.setAttribute('d', field.pathD);
        pathEl.setAttribute('fill', 'none');
        curvedPaths.appendChild(pathEl);

        const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        g.setAttribute('class', 'curved-text-group-item');
        g.dataset.fieldId = field.id;

        const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('font-family', field.fontFamily);
        text.setAttribute('font-size', field.fontSize);
        text.setAttribute('font-style', field.fontStyle || 'normal');
        text.setAttribute('font-weight', field.fontWeight || '400');
        text.setAttribute('fill', field.color || '#000');
        if (field.letterSpacing) text.setAttribute('letter-spacing', field.letterSpacing);

        const textPath = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');
        textPath.setAttribute('href', '#' + pathId);
        textPath.setAttribute('startOffset', '0');
        textPath.textContent = value;
        text.appendChild(textPath);
        g.appendChild(text);

        g.addEventListener('click', (ev) => {
          ev.stopPropagation();
          openCurvedTextEditor(field, g, text, textPath, value);
        });
        curvedGroup.appendChild(g);
      });
    }

    function openCurvedTextEditor(field, groupEl, textEl, textPathEl, currentValue) {
      if (!curvedEditor || !curvedInput) return;
      const bbox = groupEl.getBoundingClientRect();
      curvedEditor.style.left = (bbox.left + window.scrollX) + 'px';
      curvedEditor.style.top  = (bbox.bottom + window.scrollY + 8) + 'px';
      curvedEditor.classList.add('show');
      curvedInput.value = currentValue;
      curvedInput.maxLength = field.maxLength || 40;
      curvedInput.focus(); curvedInput.select();
      groupEl.classList.add('selected');

      function close(save) {
        if (save) {
          const newValue = curvedInput.value.trim() || field.defaultValue;
          state.texts[field.id] = newValue;
          textPathEl.textContent = newValue;
        }
        curvedEditor.classList.remove('show');
        groupEl.classList.remove('selected');
        curvedInput.removeEventListener('keydown', onKey);
        curvedInput.removeEventListener('blur', onBlur);
        document.removeEventListener('click', onOutside);
      }
      function onKey(ev) {
        if (ev.key === 'Enter')  { ev.preventDefault(); close(true); }
        if (ev.key === 'Escape') { ev.preventDefault(); close(false); }
      }
      function onBlur() { setTimeout(() => close(true), 100); }
      function onOutside(ev) {
        if (!curvedEditor.contains(ev.target) && !groupEl.contains(ev.target)) close(true);
      }
      curvedInput.addEventListener('keydown', onKey);
      curvedInput.addEventListener('blur', onBlur);
      setTimeout(() => document.addEventListener('click', onOutside), 10);
    }

    // ============================================================
    //  UPLOAD DE FOTO
    // ============================================================
    // Flag para suprimir el file picker si el usuario estaba arrastrando
    let _suppressNextZoneClick = false;

    function handleZoneClick(zoneId, e) {
      // Evitar que el click llegue al form de Shopify y dispare submit
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      // Si hubo un drag real (movimiento > 5px), no abrir el picker
      if (_suppressNextZoneClick) return;

      state.pendingZoneId = zoneId;
      const fi = fileInput || window.__personalizerFileInput;
      if (!fi) {
        console.error('[personalizer] No se encontró el input de archivo');
        return;
      }
      // Reset value para que re-seleccionar el mismo archivo dispare onChange
      try { fi.value = ''; } catch (_) {}
      try {
        fi.click();
      } catch (err) {
        console.error('[personalizer] error abriendo file picker:', err);
      }
    }
    function selectZone(id) {
      state.selectedZone = id;
      wrap.querySelectorAll('.photo-zone').forEach(el => {
        el.classList.toggle('selected', el.dataset.zoneId === id);
      });
    }

    if (!fileInput) {
      console.warn('[personalizer] No se encontró .personalizer-file-input en el DOM. Creándolo dinámicamente.');
      // Si el Liquid no lo tiene, lo creamos al vuelo dentro del wrap
      const dynamicInput = document.createElement('input');
      dynamicInput.type = 'file';
      dynamicInput.className = 'personalizer-file-input';
      dynamicInput.accept = 'image/*';
      dynamicInput.style.display = 'none';
      document.body.appendChild(dynamicInput);
      // re-asignar la variable a través de un objeto
      window.__personalizerFileInput = dynamicInput;
    }
    const _fi = fileInput || window.__personalizerFileInput;

    // Comprime/redimensiona una imagen si supera maxBytes (límite Shopify: 4 MB en properties)
    function prepareImageFile(file, maxBytes, onReady) {
      maxBytes = maxBytes || 3.8 * 1024 * 1024; // 3.8 MB — margen bajo el límite de Shopify
      if (file.size <= maxBytes) { onReady(file); return; }

      const reader = new FileReader();
      reader.onload = function(ev) {
        const img = new Image();
        img.onload = function() {
          // Reducir dimensiones si la imagen es muy grande
          const ratio = file.size / maxBytes;
          const scale = ratio > 8 ? 0.4 : ratio > 4 ? 0.6 : ratio > 2 ? 0.75 : 0.9;
          const canvas = document.createElement('canvas');
          canvas.width  = Math.round(img.width  * scale);
          canvas.height = Math.round(img.height * scale);
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Intentar con calidad 0.88 primero, luego reducir si sigue grande
          function tryQuality(q) {
            canvas.toBlob(function(blob) {
              if (blob && blob.size > maxBytes && q > 0.5) {
                tryQuality(q - 0.1);
              } else {
                const compressed = new File(
                  [blob || new Blob()],
                  file.name.replace(/\.[^.]+$/, '.jpg'),
                  { type: 'image/jpeg' }
                );
                onReady(compressed);
              }
            }, 'image/jpeg', q);
          }
          tryQuality(0.88);
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    }

    _fi.addEventListener('change', e => {
      const file = e.target.files[0];
      if (!file || !state.pendingZoneId) return;
      const zoneId = state.pendingZoneId;
      state.pendingZoneId = null;

      prepareImageFile(file, 3.8 * 1024 * 1024, function(readyFile) {
        // 1. Mostrar preview local de inmediato (FileReader → data URL para canvas)
        const reader = new FileReader();
        reader.onload = ev => {
          state.photos[zoneId] = ev.target.result;
          state.offsets[zoneId] = {x:50,y:50};
          renderCanvas();
          setStatus(t('photoUploaded'));
        };
        reader.readAsDataURL(readyFile);

        // 2. Copiar el archivo al input específico de zona (properties[Photo X])
        const zoneInput = document.querySelector('.pph-zone-file-input[data-zone-id="' + zoneId + '"]');
        if (zoneInput) {
          try {
            const dt = new DataTransfer();
            dt.items.add(readyFile);
            zoneInput.files = dt.files;
          } catch (err) {
            console.warn('[personalizer] no se pudo copiar archivo al input de zona:', err);
          }
        }
      });

      _fi.value = '';
    });

    async function uploadToCloudinary(file) {
      state.uploading++;
      try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`, {
          method: 'POST', body: fd
        });
        if (!res.ok) throw new Error('Cloudinary HTTP ' + res.status);
        const data = await res.json();
        return data.secure_url;
      } finally {
        state.uploading--;
      }
    }

    // ============================================================
    //  DRAG ENCUADRE
    // ============================================================
    let dragState = null;
    function attachDragHandlers() {
      wrap.querySelectorAll('.photo-zone').forEach(el => {
        const zoneId = el.dataset.zoneId;
        if (!state.photos[zoneId]) return;
        el.addEventListener('mousedown', e => {
          e.preventDefault();
          selectZone(zoneId);
          const img = el.querySelector('img');
          const off = state.offsets[zoneId] || {x:50,y:50};
          dragState = {
            zoneId, el, img,
            startX: e.clientX, startY: e.clientY,
            startOff: {...off},
            elRect: el.getBoundingClientRect()
          };
          el.classList.add('dragging');
        });
        el.addEventListener('touchstart', e => {
          const t = e.touches[0];
          selectZone(zoneId);
          const img = el.querySelector('img');
          const off = state.offsets[zoneId] || {x:50,y:50};
          dragState = {
            zoneId, el, img,
            startX: t.clientX, startY: t.clientY,
            startOff: {...off},
            elRect: el.getBoundingClientRect(),
            startTime: Date.now(),
            moved: false
          };
          el.classList.add('dragging');
          e.preventDefault();
        }, {passive:false});

        // Detectar tap en zona con foto para abrir picker en mobile
        el.addEventListener('touchend', e => {
          if (!dragState || dragState.zoneId !== zoneId) return;
          const wasTap = !dragState.moved && (Date.now() - dragState.startTime) < 300;
          if (wasTap) {
            e.preventDefault();
            state.pendingZoneId = zoneId;
            const fi = fileInput || window.__personalizerFileInput;
            if (fi) {
              try { fi.value = ''; } catch (_) {}
              try { fi.click(); } catch (err) {}
            }
          }
        }, {passive:false});
      });
    }
    function handleMove(cx, cy) {
      if (!dragState) return;
      const dx = cx - dragState.startX;
      const dy = cy - dragState.startY;
      // Si el movimiento supera 5px, es un drag real → suprimir el click siguiente
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        _suppressNextZoneClick = true;
        dragState.moved = true;
      }
      const offX = Math.max(0, Math.min(100, dragState.startOff.x - (dx / dragState.elRect.width) * 100));
      const offY = Math.max(0, Math.min(100, dragState.startOff.y - (dy / dragState.elRect.height) * 100));
      state.offsets[dragState.zoneId] = {x: offX, y: offY};
      dragState.img.style.objectPosition = `${offX}% ${offY}%`;
    }
    window.addEventListener('mousemove', e => handleMove(e.clientX, e.clientY));
    window.addEventListener('touchmove', e => {
      if (dragState) { handleMove(e.touches[0].clientX, e.touches[0].clientY); e.preventDefault(); }
    }, {passive:false});
    window.addEventListener('mouseup', () => {
      if (dragState) { dragState.el.classList.remove('dragging'); dragState = null; }
      // Dar tiempo a que el evento click se procese antes de limpiar el flag
      setTimeout(() => { _suppressNextZoneClick = false; }, 200);
    });
    window.addEventListener('touchend', () => {
      if (dragState) { dragState.el.classList.remove('dragging'); dragState = null; }
      setTimeout(() => { _suppressNextZoneClick = false; }, 200);
    });

    // ============================================================
    //  CUSTOM TEXTS (añadir / mover / resize / borrar)
    // ============================================================
    let ctDragState = null;

    function addCustomText() {
      const tpl = state.tpl;
      const id = 'ct_' + (++state.customTextIdCounter);
      const newText = {
        id,
        x: tpl.viewBox.w / 2, y: tpl.viewBox.h / 2,
        text: t('defaultText'),
        fontSize: 24,
        fontFamily: '"Dancing Script", cursive',
        color: '#1a1a1a',
        bold: false, italic: false, rotation: 0
      };
      state.customTexts.push(newText);
      state.selectedCustomTextId = id;
      renderCanvas();
      requestAnimationFrame(() => {
        const el = wrap.querySelector(`[data-ct-id="${id}"]`);
        if (el) showTextToolbar(el, newText);
      });
      setStatus(t('textAdded'));
    }

    function renderCustomTexts(tpl, vb) {
      state.customTexts.forEach(ct => {
        const el = document.createElement('div');
        el.className = 'custom-text';
        if (ct.id === state.selectedCustomTextId) el.classList.add('selected');
        el.dataset.ctId = ct.id;
        el.style.left = (ct.x / vb.w * 100) + '%';
        el.style.top  = (ct.y / vb.h * 100) + '%';
        el.style.fontSize = ((ct.fontSize / vb.w) * 100) + 'cqw';
        el.style.fontFamily = ct.fontFamily;
        el.style.color = ct.color;
        el.style.fontWeight = ct.bold ? '700' : '400';
        el.style.fontStyle = ct.italic ? 'italic' : 'normal';
        el.style.transform = `translate(-50%, -50%) rotate(${ct.rotation}deg)`;
        el.textContent = ct.text;
        el.setAttribute('contenteditable', 'false');
        el.setAttribute('spellcheck', 'false');

        el.addEventListener('click', (ev) => {
          if (el.classList.contains('editing')) return;
          ev.stopPropagation();
          state.selectedCustomTextId = ct.id;
          wrap.querySelectorAll('.custom-text.selected').forEach(e => e.classList.remove('selected'));
          el.classList.add('selected');
          showTextToolbar(el, ct);
        });
        el.addEventListener('dblclick', (ev) => {
          ev.stopPropagation();
          el.classList.add('editing');
          el.setAttribute('contenteditable', 'true');
          el.focus();
          const range = document.createRange();
          range.selectNodeContents(el);
          const sel = window.getSelection();
          sel.removeAllRanges(); sel.addRange(range);
        });
        el.addEventListener('keydown', (ev) => {
          if (ev.key === 'Enter' || ev.key === 'Escape') { ev.preventDefault(); el.blur(); }
        });
        el.addEventListener('blur', () => {
          if (!el.classList.contains('editing')) return;
          ct.text = el.textContent.trim() || t('defaultText');
          el.textContent = ct.text;
          el.classList.remove('editing');
          el.setAttribute('contenteditable', 'false');
          window.getSelection().removeAllRanges();
        });
        el.addEventListener('mousedown', (ev) => {
          if (el.classList.contains('editing')) return;
          if (ev.target.classList.contains('resize-handle')) return;
          ev.preventDefault();
          const canvasRect = canvasBg.getBoundingClientRect();
          ctDragState = {
            mode: 'move', ct, el,
            startMX: ev.clientX, startMY: ev.clientY,
            startX: ct.x, startY: ct.y,
            canvasW: canvasRect.width, canvasH: canvasRect.height, vb
          };
        });

        if (ct.id === state.selectedCustomTextId) {
          ['tl','tr','bl','br'].forEach(pos => {
            const h = document.createElement('div');
            h.className = 'resize-handle ' + pos;
            h.addEventListener('mousedown', (ev) => {
              ev.stopPropagation(); ev.preventDefault();
              ctDragState = {
                mode: 'resize', ct, el,
                startMX: ev.clientX, startMY: ev.clientY,
                startFS: ct.fontSize,
                startRect: el.getBoundingClientRect()
              };
            });
            el.appendChild(h);
          });
        }
        textsContainer.appendChild(el);
      });
    }

    window.addEventListener('mousemove', (ev) => {
      if (!ctDragState) return;
      const dx = ev.clientX - ctDragState.startMX;
      const dy = ev.clientY - ctDragState.startMY;
      if (ctDragState.mode === 'move') {
        const dvx = (dx / ctDragState.canvasW) * ctDragState.vb.w;
        const dvy = (dy / ctDragState.canvasH) * ctDragState.vb.h;
        ctDragState.ct.x = Math.max(0, Math.min(ctDragState.vb.w, ctDragState.startX + dvx));
        ctDragState.ct.y = Math.max(0, Math.min(ctDragState.vb.h, ctDragState.startY + dvy));
        ctDragState.el.style.left = (ctDragState.ct.x / ctDragState.vb.w * 100) + '%';
        ctDragState.el.style.top  = (ctDragState.ct.y / ctDragState.vb.h * 100) + '%';
        updateToolbarPosition();
      } else if (ctDragState.mode === 'resize') {
        const delta = Math.max(Math.abs(dx), Math.abs(dy)) * Math.sign(dx + dy || 1);
        const scale = (ctDragState.startRect.width + delta) / ctDragState.startRect.width;
        const newSize = Math.max(6, Math.min(120, ctDragState.startFS * scale));
        ctDragState.ct.fontSize = newSize;
        const vb = state.tpl.viewBox;
        ctDragState.el.style.fontSize = ((newSize / vb.w) * 100) + 'cqw';
        if (tbSize) tbSize.value = Math.round(newSize);
        updateToolbarPosition();
      }
    });
    window.addEventListener('mouseup', () => { ctDragState = null; });

    canvasBg.addEventListener('click', (ev) => {
      if (!ev.target.closest('.custom-text') && !ev.target.classList.contains('resize-handle')) {
        if (state.selectedCustomTextId !== null) {
          state.selectedCustomTextId = null;
          hideTextToolbar();
          renderCanvas();
        }
      }
    });

    function showTextToolbar(el, ct) {
      if (!textToolbar) return;
      textToolbar.classList.add('show');
      if (tbFont)  tbFont.value  = ct.fontFamily;
      if (tbSize)  tbSize.value  = Math.round(ct.fontSize);
      if (tbColor) tbColor.value = ct.color;
      if (tbBold)   tbBold.classList.toggle('active', ct.bold);
      if (tbItalic) tbItalic.classList.toggle('active', ct.italic);
      updateToolbarPosition();
    }
    function updateToolbarPosition() {
      if (!textToolbar || !state.selectedCustomTextId) return;
      const el = wrap.querySelector(`[data-ct-id="${state.selectedCustomTextId}"]`);
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const tbRect = textToolbar.getBoundingClientRect();
      let left = rect.left + rect.width / 2 - tbRect.width / 2;
      let top  = rect.top - tbRect.height - 12;
      if (top < 10) top = rect.bottom + 12;
      left = Math.max(10, Math.min(window.innerWidth - tbRect.width - 10, left));
      textToolbar.style.left = left + 'px';
      textToolbar.style.top  = (top + window.scrollY) + 'px';
    }
    function hideTextToolbar() {
      if (textToolbar) textToolbar.classList.remove('show');
    }
    function getSelectedCT() {
      return state.customTexts.find(c => c.id === state.selectedCustomTextId);
    }

    if (tbFont) tbFont.addEventListener('change', () => {
      const ct = getSelectedCT(); if (!ct) return;
      ct.fontFamily = tbFont.value; renderCanvas();
      requestAnimationFrame(updateToolbarPosition);
    });
    if (tbSize) tbSize.addEventListener('input', () => {
      const ct = getSelectedCT(); if (!ct) return;
      const v = parseInt(tbSize.value) || 24;
      ct.fontSize = Math.max(6, Math.min(120, v));
      const vb = state.tpl.viewBox;
      const el = wrap.querySelector(`[data-ct-id="${ct.id}"]`);
      if (el) el.style.fontSize = ((ct.fontSize / vb.w) * 100) + 'cqw';
      requestAnimationFrame(updateToolbarPosition);
    });
    if (tbBold) tbBold.addEventListener('click', () => {
      const ct = getSelectedCT(); if (!ct) return;
      ct.bold = !ct.bold;
      tbBold.classList.toggle('active', ct.bold);
      const el = wrap.querySelector(`[data-ct-id="${ct.id}"]`);
      if (el) el.style.fontWeight = ct.bold ? '700' : '400';
    });
    if (tbItalic) tbItalic.addEventListener('click', () => {
      const ct = getSelectedCT(); if (!ct) return;
      ct.italic = !ct.italic;
      tbItalic.classList.toggle('active', ct.italic);
      const el = wrap.querySelector(`[data-ct-id="${ct.id}"]`);
      if (el) el.style.fontStyle = ct.italic ? 'italic' : 'normal';
    });
    if (tbColor) tbColor.addEventListener('input', () => {
      const ct = getSelectedCT(); if (!ct) return;
      ct.color = tbColor.value;
      const el = wrap.querySelector(`[data-ct-id="${ct.id}"]`);
      if (el) el.style.color = ct.color;
    });
    if (tbDelete) tbDelete.addEventListener('click', () => {
      if (!state.selectedCustomTextId) return;
      state.customTexts = state.customTexts.filter(c => c.id !== state.selectedCustomTextId);
      state.selectedCustomTextId = null;
      hideTextToolbar();
      renderCanvas();
    });
    if (addTextBtn) addTextBtn.addEventListener('click', addCustomText);

    window.addEventListener('scroll', updateToolbarPosition);
    window.addEventListener('resize', updateToolbarPosition);

    // ============================================================
    //  COMPOSITE — genera la imagen final para producción
    // ============================================================
    function drawCompositeToCanvas(canvas, ctx, W, H, onDone) {
      const tpl = state.tpl;
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, W, H);

      // Para tazas sublimadas, el área de impresión NO cubre los 360 grados —
      // hay un espacio sin diseño donde va el asa. Esto reserva esa zona blanca
      // a izquierda y derecha del canvas (que en el modelo 3D queda detrás del handle).
      const PRINT_U_START = 0.069, PRINT_U_END = 0.931;
      const printX = PRINT_U_START * W;
      const printY = 0;
      const printW = (PRINT_U_END - PRINT_U_START) * W;
      const printH = H;

      const vb = tpl.viewBox;
      const tplRatio = vb.w / vb.h;
      const prRatio = printW / printH;
      let designW, designH, designX, designY;
      if (tplRatio < prRatio) {
        designH = printH; designW = designH * tplRatio;
        designX = printX + (printW - designW) / 2; designY = printY;
      } else {
        designW = printW; designH = designW / tplRatio;
        designX = printX; designY = printY + (printH - designH) / 2;
      }
      const scaleX = designW / vb.w;

      function drawBg() {
        return new Promise(res => {
          if (!tpl.backgroundImage) { res(); return; }
          const im = new Image();
          im.crossOrigin = 'anonymous';
          im.onload = () => {
            ctx.drawImage(im, designX, designY, designW, designH);
            res();
          };
          im.onerror = res;
          im.src = tpl.backgroundImage;
        });
      }
      function drawZones() {
        return new Promise(res => {
          const zones = [...(tpl.photoZones || [])].sort((a,b) => (a.z||1) - (b.z||1));
          let i = 0;
          (function next() {
            if (i >= zones.length) { res(); return; }
            const zone = zones[i++];
            const src = state.photos[zone.id];
            if (!src) { next(); return; }
            const off = state.offsets[zone.id] || {x:50,y:50};
            const im = new Image();
            im.crossOrigin = 'anonymous';
            im.onload = () => {
              ctx.save();
              const zx = designX + (zone.x / vb.w) * designW;
              const zy = designY + (zone.y / vb.h) * designH;
              const zw = (zone.w / vb.w) * designW;
              const zh = (zone.h / vb.h) * designH;
              ctx.translate(zx + zw/2, zy + zh/2);
              ctx.rotate((zone.rotation || 0) * Math.PI / 180);
              if (zone.customPath) {
                const shapePath = new Path2D();
                const cmds = zone.customPath.match(/[MLZ][^MLZ]*/g) || [];
                cmds.forEach(cmd => {
                  const type = cmd[0];
                  if (type === 'Z') { shapePath.closePath(); return; }
                  const coords = cmd.substr(1).split(',').map(parseFloat);
                  const nx = (coords[0] / 100) * zw - zw/2;
                  const ny = (coords[1] / 100) * zh - zh/2;
                  if (type === 'M') shapePath.moveTo(nx, ny);
                  else if (type === 'L') shapePath.lineTo(nx, ny);
                });
                ctx.clip(shapePath);
              } else if (zone.shape === 'circle') {
                ctx.beginPath();
                ctx.arc(0, 0, Math.min(zw, zh) / 2, 0, Math.PI * 2);
                ctx.clip();
              } else {
                ctx.beginPath();
                ctx.rect(-zw/2, -zh/2, zw, zh);
                ctx.clip();
              }
              const imgR = im.width/im.height, zoneR = zw/zh;
              let sx=0, sy=0, sw=im.width, sh=im.height;
              if (imgR > zoneR) {
                sw = im.height * zoneR;
                sx = (im.width - sw) * (off.x/100);
              } else {
                sh = im.width / zoneR;
                sy = (im.height - sh) * (off.y/100);
              }
              ctx.drawImage(im, sx, sy, sw, sh, -zw/2, -zh/2, zw, zh);
              ctx.restore();
              next();
            };
            im.onerror = next;
            im.src = src;
          })();
        });
      }
      function drawTexts() {
        return new Promise(res => {
          (tpl.textFields || []).forEach(field => {
            const value = state.texts[field.id] !== undefined ? state.texts[field.id] : field.defaultValue;
            if (!value) return;
            ctx.save();
            const tx = designX + (field.x / vb.w) * designW;
            const ty = designY + (field.y / vb.h) * designH;
            const fontSizePx = field.fontSize * scaleX;
            ctx.font = `${field.fontStyle || 'normal'} ${field.fontWeight || '400'} ${fontSizePx}px ${field.fontFamily}`;
            ctx.fillStyle = field.color;
            ctx.textAlign = field.align || 'center';
            ctx.textBaseline = 'middle';
            if (field.letterSpacing && ctx.letterSpacing !== undefined) {
              ctx.letterSpacing = (field.letterSpacing * scaleX) + 'px';
            }
            if (field.rotation) {
              ctx.translate(tx, ty);
              ctx.rotate(field.rotation * Math.PI / 180);
              ctx.fillText(value, 0, 0);
            } else {
              ctx.fillText(value, tx, ty);
            }
            if (field.letterSpacing && ctx.letterSpacing !== undefined) ctx.letterSpacing = '0px';
            ctx.restore();
          });

          (tpl.curvedTextFields || []).forEach(field => {
            const value = state.texts[field.id] !== undefined ? state.texts[field.id] : field.defaultValue;
            if (!value) return;
            const fontSizePx = field.fontSize * scaleX;
            const curvePoints = samplePathPoints(field.pathD, value.length + 1, vb, designX, designY, designW, designH);
            if (curvePoints.length < 2) return;
            ctx.save();
            ctx.font = `${field.fontStyle || 'normal'} ${field.fontWeight || '400'} ${fontSizePx}px ${field.fontFamily}`;
            ctx.fillStyle = field.color || '#000';
            ctx.textBaseline = 'alphabetic';
            for (let i = 0; i < value.length; i++) {
              const ch = value[i];
              const p0 = curvePoints[i];
              const p1 = curvePoints[i + 1] || p0;
              const angle = Math.atan2(p1.y - p0.y, p1.x - p0.x);
              ctx.save();
              ctx.translate(p0.x, p0.y);
              ctx.rotate(angle);
              ctx.fillText(ch, 0, 0);
              ctx.restore();
            }
            ctx.restore();
          });

          state.customTexts.forEach(ct => {
            if (!ct.text) return;
            ctx.save();
            const tx = designX + (ct.x / vb.w) * designW;
            const ty = designY + (ct.y / vb.h) * designH;
            const fontSizePx = ct.fontSize * scaleX;
            const weight = ct.bold ? '700' : '400';
            const style = ct.italic ? 'italic' : 'normal';
            ctx.font = `${style} ${weight} ${fontSizePx}px ${ct.fontFamily}`;
            ctx.fillStyle = ct.color;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.translate(tx, ty);
            if (ct.rotation) ctx.rotate(ct.rotation * Math.PI / 180);
            ctx.fillText(ct.text, 0, 0);
            ctx.restore();
          });
          res();
        });
      }
      function drawOverlay() {
        return new Promise(res => {
          if (!tpl.overlayImage) { res(); return; }
          const im = new Image();
          im.crossOrigin = 'anonymous';
          im.onload = () => {
            ctx.drawImage(im, designX, designY, designW, designH);
            res();
          };
          im.onerror = res;
          im.src = tpl.overlayImage;
        });
      }
      drawBg().then(drawZones).then(drawTexts).then(drawOverlay).then(onDone);
    }

    // Genera un Blob JPEG con el composite final
    function generatePreviewBlob(targetW = 2000) {
      return new Promise(resolve => {
        const tpl = state.tpl;
        const vb = tpl.viewBox;
        const W = targetW;
        const H = Math.round(targetW * vb.h / vb.w);
        const canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        const ctx = canvas.getContext('2d');
        drawCompositeToCanvas(canvas, ctx, W, H, () => {
          canvas.toBlob(b => resolve(b), 'image/jpeg', 0.92);
        });
      });
    }

    // ============================================================
    //  SUBMIT TO CART (sin Cloudinary — archivos van directo a Shopify)
    // ============================================================
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();

        // Validar que todas las zonas requeridas tengan foto
        const requiredZones = (state.tpl.photoZones || []).filter(z => !z.optional);
        const missing = requiredZones.filter(z => !state.photos[z.id]);
        if (missing.length > 0) {
          setStatus(t('missingPhotos', missing.length));
          return;
        }

        submitBtn.disabled = true;
        submitBtn.dataset.originalHtml = submitBtn.innerHTML;
        submitBtn.innerHTML = t('generatingPreview');

        (async () => {
        try {
          // Recopilar metadata (textos, posiciones, custom texts) en JSON
          const data = {
            template: state.tpl.name,
            templateId: state.tpl.id || wrap.dataset.template,
            offsets: state.offsets,
            texts: state.texts,
            customTexts: state.customTexts,
          };

          // Llenar properties con la metadata
          if (propsDataEl)    propsDataEl.value = JSON.stringify(data);
          if (propsPreviewEl) propsPreviewEl.value = '';  // sin Cloudinary
          if (propsPhotosEl)  propsPhotosEl.value = '';   // los archivos viajan en pph-zone-file-input

          // ─── DESIGN PREVIEW: composite propio (fondo + fotos + textos) ───
          const designFinalInput = formEl && formEl.querySelector('.pph-design-final-input');
          console.log('[personalizer] designFinalInput found:', !!designFinalInput);
          if (designFinalInput) {
            try {
              // 1200px → JPEG ~0.5-1.5 MB, bien bajo el límite de 4MB de Shopify
              const blob = await generatePreviewBlob(1200);
              console.log('[personalizer] design blob size (bytes):', blob ? blob.size : 'null');
              if (blob && blob.size > 0) {
                const finalFile = new File([blob], 'design-preview.jpg', { type: 'image/jpeg' });
                const dt = new DataTransfer();
                dt.items.add(finalFile);
                designFinalInput.files = dt.files;
                console.log('[personalizer] design file assigned to input ✓');
              } else {
                console.warn('[personalizer] blob vacío o null — no se asignó el design file');
              }
            } catch (renderErr) {
              console.warn('[personalizer] No se pudo generar el Design Preview:', renderErr);
            }
          }

          // Submit del form (los archivos en .pph-zone-file-input
          // se envían como properties[Photo X] nativos de Shopify)
          if (formEl) {
            formEl.submit();
          } else {
            console.warn('[personalizer] No se encontró el form de Shopify');
            setStatus(t('noFormFound'));
            submitBtn.disabled = false;
            submitBtn.textContent = t('addToCart');
          }
        } catch (err) {
          console.error(err);
          setStatus(t('previewGenError') + err.message);
          submitBtn.disabled = false;
          submitBtn.innerHTML = submitBtn.dataset.originalHtml || t('addToCart');
        }
        })();
      });
    }

    // ============================================================
    //  PREVIEW 2D — modal con la imagen plana del diseño final
    // ============================================================
    let _preview2dModal = null;
    let _preview2dObjectUrl = null;

    function openPreview2D() {
      // Validar que haya al menos una foto subida
      const totalZones  = (state.tpl.photoZones || []).length;
      const filledZones = Object.keys(state.photos).length;
      if (totalZones > 0 && filledZones === 0) {
        setStatus('Upload at least one photo to preview the design.');
        return;
      }

      setStatus(t('generatingPreview'));

      generatePreviewBlob(1400).then(blob => {
        // Revocar URL anterior para evitar memory leaks
        if (_preview2dObjectUrl) URL.revokeObjectURL(_preview2dObjectUrl);
        _preview2dObjectUrl = URL.createObjectURL(blob);

        // Crear modal si no existe
        if (!_preview2dModal) {
          _preview2dModal = document.createElement('div');
          _preview2dModal.style.cssText = [
            'position:fixed', 'inset:0', 'z-index:10000',
            'background:rgba(0,0,0,0.88)',
            'display:flex', 'align-items:center', 'justify-content:center',
            'padding:20px', 'box-sizing:border-box', 'flex-direction:column', 'gap:16px'
          ].join(';');

          const inner = document.createElement('div');
          inner.style.cssText = 'position:relative;max-width:min(92vw,860px);';

          const closeBtn = document.createElement('button');
          closeBtn.innerHTML = '&times;';
          closeBtn.setAttribute('aria-label', 'Close preview');
          closeBtn.style.cssText = [
            'position:absolute', 'top:-42px', 'right:0',
            'background:none', 'border:none', 'color:#fff',
            'font-size:32px', 'line-height:1', 'cursor:pointer', 'padding:4px 8px'
          ].join(';');
          closeBtn.addEventListener('click', closePreview2D);

          const img = document.createElement('img');
          img.id = 'preview2d-img-' + productId;
          img.alt = 'Design preview';
          img.style.cssText = 'width:100%;display:block;border-radius:10px;box-shadow:0 8px 40px rgba(0,0,0,0.5);';

          const caption = document.createElement('p');
          caption.textContent = 'This is how your design will print · Tap outside to close';
          caption.style.cssText = 'color:rgba(255,255,255,0.7);text-align:center;font-size:13px;margin:10px 0 0;';

          inner.appendChild(closeBtn);
          inner.appendChild(img);
          inner.appendChild(caption);
          _preview2dModal.appendChild(inner);
          document.body.appendChild(_preview2dModal);

          _preview2dModal.addEventListener('click', e => {
            if (e.target === _preview2dModal) closePreview2D();
          });
        }

        document.getElementById('preview2d-img-' + productId).src = _preview2dObjectUrl;
        _preview2dModal.style.display = 'flex';
        setStatus('');
      }).catch(err => {
        setStatus(t('previewGenError') + err.message);
      });
    }

    function closePreview2D() {
      if (_preview2dModal) _preview2dModal.style.display = 'none';
    }

    // Cerrar con Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closePreview2D();
    });

    if (previewBtn) {
      previewBtn.addEventListener('click', openPreview2D);
    }

    // ============================================================
    //  PREVIEW 3D — modal con taza rotando (Three.js)
    // ============================================================
    const preview3dModal = document.querySelector('.preview3d-modal');
    const preview3dMount = document.querySelector('.preview3d-mount');
    const preview3dClose = document.querySelector('.preview3d-close');
    let mug3d = null;

    function openPreview3D() {
      if (!preview3dModal) return;
      preview3dModal.style.display = 'flex';
      preview3dModal.classList.add('show');
      if (mug3d) mug3d.dispose();
      setTimeout(() => {
        if (typeof THREE === 'undefined') {
          preview3dMount.innerHTML = '<div style="padding:40px;text-align:center;color:#888">' + t('threeNotLoaded') + '</div>';
          return;
        }
        mug3d = createMugPreview3D(preview3dMount);
      }, 50);
    }
    function closePreview3D() {
      if (preview3dModal) {
        preview3dModal.style.display = 'none';
        preview3dModal.classList.remove('show');
      }
      if (mug3d) { mug3d.dispose(); mug3d = null; }
    }
    if (preview3dClose) preview3dClose.addEventListener('click', closePreview3D);
    if (preview3dModal) {
      preview3dModal.addEventListener('click', e => {
        if (e.target === preview3dModal) closePreview3D();
      });
    }

    function createMugPreview3D(mount) {
      if (typeof THREE === 'undefined') {
        mount.innerHTML = '<div style="padding:40px;text-align:center;color:#888">' + t('threeNotLoaded') + '</div>';
        return { dispose: () => {} };
      }
      const w = mount.clientWidth || 800;
      const h = 500;

      const scene = new THREE.Scene();
      scene.background = new THREE.Color(0xf3f0eb);

      const R = 3.6, DIAMETER = R * 2, MH = DIAMETER * 1.19, WALL = 0.22;
      const camera = new THREE.PerspectiveCamera(34, w/h, 0.1, 500);
      camera.position.set(0, MH * 0.55, 24);
      camera.lookAt(0, MH * 0.45, 0);

      const renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' });
      renderer.setSize(w, h);
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;
      mount.innerHTML = '';
      mount.appendChild(renderer.domElement);

      scene.add(new THREE.AmbientLight(0xffffff, 0.75));
      const keyL = new THREE.DirectionalLight(0xffffff, 0.6);
      keyL.position.set(10, 16, 14);
      keyL.castShadow = true;
      keyL.shadow.mapSize.set(2048, 2048);
      keyL.shadow.radius = 4;
      keyL.shadow.bias = -0.002;
      scene.add(keyL);
      const fillL = new THREE.DirectionalLight(0xffffff, 0.35);
      fillL.position.set(-12, 10, 8);
      scene.add(fillL);
      const backL = new THREE.DirectionalLight(0xffffff, 0.15);
      backL.position.set(2, 5, -14);
      scene.add(backL);

      // Texture canvas - alta resolución para el preview de impresión
      const texCanvas = document.createElement('canvas');
      texCanvas.width = 4096;
      texCanvas.height = 1559;
      const tctx = texCanvas.getContext('2d');
      tctx.fillStyle = '#fff';
      tctx.fillRect(0, 0, texCanvas.width, texCanvas.height);

      const texture = new THREE.CanvasTexture(texCanvas);
      if (THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
      texture.flipY = true;
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.minFilter = THREE.LinearMipmapLinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.generateMipmaps = true;
      texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
      texture.offset.x = 0.50;
      texture.needsUpdate = true;

      // Cuerpo exterior (cilindro cerrado)
      const outerGeom = new THREE.CylinderGeometry(R, R, MH, 128, 1, false);
      const ceramicMat = new THREE.MeshStandardMaterial({
        map: texture, color: 0xffffff, roughness: 0.35, metalness: 0.0
      });
      const body = new THREE.Mesh(outerGeom, ceramicMat);
      body.position.y = MH / 2;
      body.castShadow = true;
      body.receiveShadow = true;

      // Material blanco genérico (cubiertas y asa)
      const whiteMat = new THREE.MeshStandardMaterial({
        color: 0xf8f8f8, roughness: 0.2, metalness: 0.0
      });

      // Tapa superior e inferior
      const topCover = new THREE.Mesh(new THREE.CircleGeometry(R + 0.005, 64), whiteMat);
      topCover.rotation.x = -Math.PI / 2;
      topCover.position.y = MH + 0.002;
      const bottomCover = new THREE.Mesh(new THREE.CircleGeometry(R + 0.005, 64), whiteMat);
      bottomCover.rotation.x = Math.PI / 2;
      bottomCover.position.y = -0.002;

      // Pared interior (BackSide para verla por dentro al inclinar)
      const innerGeom = new THREE.CylinderGeometry(R - WALL, R - WALL, MH * 0.96, 128, 1, true);
      const innerMat = new THREE.MeshStandardMaterial({
        color: 0xeeebe5, roughness: 0.45, metalness: 0, side: THREE.BackSide
      });
      const innerMesh = new THREE.Mesh(innerGeom, innerMat);
      innerMesh.position.y = MH / 2 + MH * 0.02;

      // Fondo interior (visible al mirar dentro)
      const insideBottom = new THREE.Mesh(
        new THREE.CircleGeometry(R - WALL, 128),
        new THREE.MeshStandardMaterial({ color: 0xe5e2dc, roughness: 0.6 })
      );
      insideBottom.rotation.x = -Math.PI / 2;
      insideBottom.position.y = MH * 0.04;

      // Borde superior (rim)
      const rimRing = new THREE.Mesh(
        new THREE.RingGeometry(R - WALL, R + 0.005, 128),
        whiteMat
      );
      rimRing.rotation.x = -Math.PI / 2;
      rimRing.position.y = MH + 0.003;

      // ASA — TubeGeometry siguiendo una curva CatmullRom
      const H_THICK = 0.45, H_REACH = 3.1;
      const H_TOP_ATTACH = MH * 0.78, H_BOT_ATTACH = MH * 0.18;
      const handleCurve = new THREE.CatmullRomCurve3([
        new THREE.Vector3(0, H_TOP_ATTACH, -R),
        new THREE.Vector3(0, H_TOP_ATTACH + 0.2, -(R + 1.2)),
        new THREE.Vector3(0, H_TOP_ATTACH - 0.5, -(R + H_REACH * 0.85)),
        new THREE.Vector3(0, MH * 0.55, -(R + H_REACH)),
        new THREE.Vector3(0, MH * 0.4, -(R + H_REACH)),
        new THREE.Vector3(0, H_BOT_ATTACH + 0.5, -(R + H_REACH * 0.85)),
        new THREE.Vector3(0, H_BOT_ATTACH - 0.2, -(R + 1.2)),
        new THREE.Vector3(0, H_BOT_ATTACH, -R)
      ]);
      const handleGeom = new THREE.TubeGeometry(handleCurve, 96, H_THICK, 20, false);
      const handle = new THREE.Mesh(handleGeom, whiteMat);
      handle.castShadow = true;

      // Agrupar todas las partes para rotar juntas
      const mugGroup = new THREE.Group();
      mugGroup.add(body, topCover, bottomCover, innerMesh, insideBottom, rimRing, handle);
      scene.add(mugGroup);

      // Suelo con sombra
      const floor = new THREE.Mesh(
        new THREE.CircleGeometry(20, 64),
        new THREE.MeshStandardMaterial({ color: 0xeae7e0, roughness: 0.95 })
      );
      floor.rotation.x = -Math.PI / 2;
      floor.position.y = -0.01;
      floor.receiveShadow = true;
      scene.add(floor);

      // Re-dibujar la textura con el composite del personalizador
      function updateTexture() {
        drawCompositeToCanvas(texCanvas, tctx, texCanvas.width, texCanvas.height, () => {
          texture.needsUpdate = true;
        });
      }

      // Animación: auto-rotación + drag manual
      let raf = null, rot = 0.5, isDrag = false, dragX = 0, rotSnap = 0;
      function animate() {
        raf = requestAnimationFrame(animate);
        if (!isDrag) rot += 0.004;
        mugGroup.rotation.y = rot;
        renderer.render(scene, camera);
      }
      animate();
      setTimeout(updateTexture, 150);

      function onDown(e) {
        isDrag = true; dragX = e.clientX; rotSnap = rot;
        renderer.domElement.style.cursor = 'grabbing';
      }
      function onMove(e) {
        if (!isDrag) return;
        rot = rotSnap + (e.clientX - dragX) * 0.01;
      }
      function onUp() {
        isDrag = false;
        renderer.domElement.style.cursor = 'grab';
      }
      renderer.domElement.addEventListener('pointerdown', onDown);
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);

      function onResize() {
        const nw = mount.clientWidth || 800;
        camera.aspect = nw / h;
        camera.updateProjectionMatrix();
        renderer.setSize(nw, h);
      }
      window.addEventListener('resize', onResize);

      let ro = null;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(entries => {
          for (const e of entries) {
            if (e.contentRect.width > 0 && Math.abs(e.contentRect.width - renderer.domElement.width / renderer.getPixelRatio()) > 2) {
              onResize();
            }
          }
        });
        ro.observe(mount);
      }
      setTimeout(onResize, 100);

      return {
        dispose() {
          cancelAnimationFrame(raf);
          renderer.domElement.removeEventListener('pointerdown', onDown);
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
          window.removeEventListener('resize', onResize);
          if (ro) { ro.disconnect(); ro = null; }
          if (mount.contains(renderer.domElement)) mount.removeChild(renderer.domElement);
          renderer.dispose();
          outerGeom.dispose(); innerGeom.dispose(); handleGeom.dispose();
          texture.dispose();
        }
      };
    }

    // ============================================================
    //  RESET BUTTON
    // ============================================================
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        if (!confirm(t('confirmReset'))) return;
        state.photos = {};
        state.photoUrls = {};
        state.offsets = {};
        state.texts = {};
        state.customTexts = [];
        state.selectedZone = null;
        state.selectedCustomTextId = null;
        hideTextToolbar();
        renderCanvas();
        updateStepIndicator();
        setStatus(t('photosReset'));
      });
    }

    // ============================================================
    //  STEP INDICATOR — actualiza qué paso está activo según estado
    // ============================================================
    function updateStepIndicator() {
      if (!stepIndicator) return;
      const photoCount = Object.keys(state.photos).length;
      const totalZones = (state.tpl.photoZones || []).length;
      const allFilled = photoCount >= totalZones;
      const someFilled = photoCount > 0;

      const steps = stepIndicator.querySelectorAll('.step');
      steps.forEach(s => s.classList.remove('step-active'));

      let activeStep;
      if (!someFilled) activeStep = 1;          // todavía sin fotos
      else if (!allFilled) activeStep = 1;      // subiendo fotos
      else activeStep = 3;                       // todo listo, ir a vista previa

      const target = stepIndicator.querySelector(`[data-step="${activeStep}"]`);
      if (target) target.classList.add('step-active');
    }

    // Hook updateStepIndicator into render flow
    const _origRender = renderCanvas;
    // Re-wire is tricky (renderCanvas is called from many places).
    // Simpler: call updateStepIndicator after key actions
    fileInput && fileInput.addEventListener('change', () => setTimeout(updateStepIndicator, 100));
    if (window.__personalizerFileInput) window.__personalizerFileInput.addEventListener('change', () => setTimeout(updateStepIndicator, 100));

    // ============================================================
    //  INIT
    // ============================================================
    renderCanvas();
    updateStepIndicator();
    setStatus(t('clickToUpload'));
  }
})();